module.exports = __webpack_public_path__ + "static/media/porductos_altena_tortilla.2cb75be8.jpg";